export default "__VITE_PUBLIC_ASSET__f0e17830__"